<template>
  <div id="events-day-widget-server">
    <default-events-day-widget-server
      v-if="getGameConsole === 'default'"
    ></default-events-day-widget-server>
    <market-view-events-day-widget-server
      v-if="getGameConsole === 'marketview'"
    ></market-view-events-day-widget-server>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultEventsDayWidgetServer from '@/components/center_widgets/Previews/DefaultEventsDayWidgetServer'
import MarketViewEventsDayWidgetServer from '@/components/center_widgets/Previews/MarketViewEventsDayWidgetServer'

export default {
  name: 'EventsDayWidgetServer',
  components: {
    DefaultEventsDayWidgetServer,
    MarketViewEventsDayWidgetServer,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
    }),
  },
}
</script>

<style></style>
